/* eslint-disable */
export default {
  ok: 'Aceptar',
} as const;

// @key: @#@"ok"@#@ @source: @#@"OK"@#@
